import { useState, useEffect } from 'react'
import { Modal } from 'components'
import toast from 'react-hot-toast'
import { lang } from 'config'
import { useAuth } from "contexts/auth-context"
import { useSWRConfig } from "swr"
import { executeAPI } from 'repositories/db-repository'
import { useLocation, useNavigate } from "react-router-dom"
import { insertPurchaseTransaction, updatePurchaseTransaction } from 'helpers/transaction-helper'
import { getMinimumDiscount } from 'helpers/general-helper'


const Content = ({ productUnitSelection, productItems, add, item, data, onSubmit }) => {
    const { user, isSuper } = useAuth()
    const { cache } = useSWRConfig()
    const location = useLocation()
    const navigate = useNavigate()
    const [discount, set_discount] = useState()
    const [nett_price, set_nett_price] = useState()
    const [ga_product_unit_id, set_ga_product_unit_id] = useState()
    const [ga_product_unit_long_name, set_ga_product_unit_long_name] = useState()
    const [ga_item_count, set_ga_item_count] = useState()
    const [total_ga_item_count, set_total_ga_item_count] = useState()
    const [arr_ga_product_item, set_arr_ga_product_item] = useState()
    const tmp_selectedProductUnit = productUnitSelection?.data.find((row) => row.product_unit_id === item?.product_unit_id)
        
    // alert(JSON.stringify(item))

    useEffect(() => {
        calculateDiscount(tmp_selectedProductUnit, 0)
    }, [])

    const deleteItem = () => {
        toast.loading("Loading", {
            id: "submit"
        })

        const onSuccess = (result, message) => {
            cache.clear()
            navigate({ pathname: `/purchase/${data?.purchase_transaction?.id ?? data?.id}/edit` })
            toast.success("Product berhasil dihapus!", {
                id: "submit"
            })
        }
    
        const onError = (message) => {
            toast.error("onError: " + message, {
                id: "submit"
            })
        }

        executeAPI(`${process.env.REACT_APP_REMAX_PS_API_URL}`, "update_purchase_item", 
        {
            item_type: item?.item_type,
            origin: data?.purchase_header?.origin ?? data?.origin,
            outlet_group_id: data?.purchase_header?.outlet_group_id ?? data?.outlet_group_id,
            outlet_group_name: data?.purchase_header?.outlet_group_name ?? data?.outlet_group_name,
            purchase_header_id: data?.purchase_header?.id ?? data?.purchase_header_id,
            product_unit_id: item?.product_unit_id,
            ga_product_unit_id: ga_product_unit_id,
            ga_product_unit_long_name: ga_product_unit_long_name,
            ga_item_count: total_ga_item_count,
            arr_ga_product_item: arr_ga_product_item,
            record_status: "D",
            deleted_by: user?.name
        },
        onSuccess, onError)
    }

    const handleSubmit = () => {

        const onSuccess = (result, message) => {
            toast.success("Purchase berhasil disimpan!", {
                id: "submit"
            })
            data.id = result?.purchase_transaction_id;
            data.purchase_header_id = result?.purchase_header_id;
            deleteItem();
        }
    
        const onError = (message) => {
            toast.error("onError PT: " + message, {
                id: "submit"
            })
        }

        if (data.warehouse_name && data.supplier_name && data.warehouse_address) {
            if (data?.id !== null && data?.id !== undefined) {
                toast.loading("Loading", {
                    id: "submit"
                })

                updatePurchaseTransaction(data, user?.name, onSuccess, onError) 

            } else if (data?.id == null || data?.id == undefined) {
                toast.loading("Loading", {
                    id: "submit"
                })

                insertPurchaseTransaction(data, user?.name, onSuccess, onError) 

            } else {
                deleteItem()
            }
        } else {
            toast.error("Data purchase tidak lengkap!", {
                id: "submit"
            })
            onSubmit()
        }
    }

    const calculateDiscount = (tmp_selectedProductUnit, tmp_quantity) => {
        var tmp_discount = 0
        var total_discount = 0
        var tmp_quantity_existing = 0
        var tmp_ga_quantity = 0
        var tmp_ga_quantity_existing = 0
        var tmp_quantity_all = 0

        // alert(JSON.stringify(tmp_selectedProductUnit))
        // alert(JSON.stringify(productItems))

        if (productItems) {
            const tmp_productItem = productItems?.find((row) => row.product_unit_id === tmp_selectedProductUnit.product_unit_id)
            if (tmp_productItem) {
                tmp_quantity_existing = tmp_productItem.po_quantity
            }
        }

        if (add === true) {
            tmp_quantity_all = tmp_quantity+tmp_quantity_existing
        } else {
            tmp_quantity_all = tmp_quantity
        }

        for (var i = 1; i <= tmp_quantity_all; i++) {
            tmp_discount = 0
            if (tmp_quantity_all >= Number(tmp_selectedProductUnit.sales_item_count)) {
                if (i >= Number(tmp_selectedProductUnit.starting_item_number)) {
                    tmp_discount = getMinimumDiscount(Number(tmp_selectedProductUnit.price)*(Number(tmp_selectedProductUnit.discount_percentage) ?? 0)/100, 
                    (Number(tmp_selectedProductUnit.max_discount_amount) ?? 0))
                }
            }
            total_discount += tmp_discount
            if (Number(tmp_selectedProductUnit.multiply) == 0) {
                break
            }
        }

        if (tmp_selectedProductUnit?.ga_product_unit_id) {
            tmp_ga_quantity = Math.floor((tmp_quantity_all) / Number(tmp_selectedProductUnit.sales_item_count))
            tmp_ga_quantity_existing = Math.floor((tmp_quantity_existing) / Number(tmp_selectedProductUnit.sales_item_count))
        }  

        set_ga_item_count(tmp_selectedProductUnit.ga_item_count*tmp_ga_quantity)
        set_total_ga_item_count(tmp_selectedProductUnit.ga_item_count*tmp_ga_quantity)
        if (tmp_selectedProductUnit?.ga_product_unit_id) {
            if (productUnitSelection) {
                const tmp_productItem = productUnitSelection?.data.find((row) => row.product_unit_id === tmp_selectedProductUnit.ga_product_unit_id)
                if (tmp_productItem) {
                    // alert(JSON.stringify(tmp_productItem))
                    set_arr_ga_product_item(JSON.stringify(tmp_productItem))
                }
            }
            set_ga_product_unit_id(tmp_selectedProductUnit?.ga_product_unit_id)
            set_ga_product_unit_long_name(tmp_selectedProductUnit?.ga_product_unit_long_name)

            if (productItems) {
                const tmp_productItem = productItems?.find((row) => 
                    row.product_unit_id === tmp_selectedProductUnit.ga_product_unit_id && 
                    row.item_type === "GA")
                if (tmp_productItem) {
                    const total = tmp_productItem.po_quantity+tmp_selectedProductUnit.ga_item_count*(tmp_ga_quantity-tmp_ga_quantity_existing)
                    set_total_ga_item_count(total)
                }
            }
        } else {
            set_arr_ga_product_item(undefined)
            set_ga_product_unit_id(undefined)
            set_ga_product_unit_long_name(undefined)
        }
        set_discount(total_discount/(tmp_quantity_all))
        set_nett_price((Number(tmp_selectedProductUnit.price)*(tmp_quantity_all) - total_discount)/(tmp_quantity_all))
    }

    return (
        <div className="mt-8 space-y-8">
            {lang.are_you_sure_you_want_to_delete} <span className="inline-flex px-3 py-1 text-sm font-medium rounded-xl bg-neutral-200 text-neutral-600">{item?.product_unit}</span> ?
            <div className="text-xs">
                <button onClick={handleSubmit} className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{lang.yes}</span>
                </button>
            </div>
        </div>
    )
}

const DeleteProduct = ({ productUnitSelection, productItems, item, add, purchase, onSubmit }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => {
        if (!(purchase.warehouse_name && purchase.supplier_name && purchase.warehouse_address)) {
            toast.error("Data purchase tidak lengkap!", {
                id: "submit"
            })
        } else {
            setIsOpen(true)
        }
    }

    const closeModal = () => setIsOpen(false)

    const handleSubmit = () => {
        closeModal()
        onSubmit()
    }

    return (
        <>
            <button disabled={false} onClick={openModal} class={`${false ? 'opacity-50 bg-red-900' : 'bg-red-800'} inline-flex items-center p-1 text-white transition rounded-full active:hover:scale-90`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <line x1={4} y1={7} x2={20} y2={7}></line>
                    <line x1={10} y1={11} x2={10} y2={17}></line>
                    <line x1={14} y1={11} x2={14} y2={17}></line>
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                </svg>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.delete} ${lang.data}`} content={<Content productUnitSelection={productUnitSelection} productItems={productItems} add={add} item={item} data={purchase} onSubmit={handleSubmit}  />} />
        </>
    )
}

export default DeleteProduct